import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props
  return (
    <svg
      height={height}
      width={width}
      {...props}
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.33333 3.99992C9.33333 5.47268 8.1394 6.66659 6.66667 6.66659C5.19391 6.66659 4 5.47268 4 3.99992C4 2.52716 5.19391 1.33325 6.66667 1.33325C8.1394 1.33325 9.33333 2.52716 9.33333 3.99992Z"
        stroke="#72808F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3332 12.6666L11.3332 12.2666V10.6666M8.6665 11.9999C8.6665 13.4727 9.86044 14.6666 11.3332 14.6666C12.8059 14.6666 13.9998 13.4727 13.9998 11.9999C13.9998 10.5272 12.8059 9.33325 11.3332 9.33325C9.86044 9.33325 8.6665 10.5272 8.6665 11.9999Z"
        stroke="#72808F"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.85"
      />
      <path
        d="M7 13.3334H3.33333C2.59695 13.3334 2 12.7365 2 12.0001C2 10.1591 3.49239 8.66675 5.33333 8.66675H8.33333"
        stroke="#72808F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgComponent
